import { createMuiTheme } from '@material-ui/core/styles';
import red from '@material-ui/core/colors/red';

let theme = createMuiTheme({
  props: {
    MuiTypography: {
      variantMapping: {
        h1: 'h1',
        h2: 'h2',
        h3: 'h3',
        h4: 'h4',
        h5: 'h5',
        h6: 'h6'
      },
    },
  },
  breakpoints: {
    values: {
      xs: 576,
      sm: 768,
      md: 992,
      lg: 1200,
      xl: 1600,
    },
  },

  'fontFamily': "'微軟正黑體', 'texgyreadventorregular' ! important",
  palette: {
    'logo': {
      'pink': 'rgb(224, 142, 187)'
    },
    primary: {
      light: 'rgba(230,112,255,1)', // primary pink 2 with opacity
      dark: 'rgba(181,56,222,1)', // primary pink 1
      main: 'rgba(198, 85, 151,1)', // primary pink 2
      "lighter": 'rgba(230,112,255,0.8)', // primary pink 2 with opacity
      "whiteTone": 'rgba(230,112,255,0.2)'
    },
    secondary: {
      light: 'rgba(163,255,217,0.8)', // primary pink 2 with opacity
      dark: 'rgba(79,255,189,1)', // primary pink 1
      main: 'rgba(163,255,217,1)', // primary pink 2
      "lighter": 'rgba(230,112,255,0.5)',
      "whiteTone": 'rgba(163,255,217,0.1)'
    },
    error: {
      main: red.A400,
    },
    success: {
      main: '#4caf50',
      light: '#81c784',
      dark: '#388e3c',
      contrastText: 'rgba(0,0,0,0.87)'
    },
    background: {
      default: '#fff',
    },
    text: {
      secondary: 'rgb(121, 37, 148)',
      primary: 'rgb(37, 37, 37)'
    }
  },
 

});

// xs: 576,
// sm: 768,
// md: 992,
// lg: 1200,
// xl: 1600,
theme.typography.h1 = {
  
  fontFamily: "'微軟正黑體', 'texgyreadventorregular' ! important",
  fontWeight: 400,
  [theme.breakpoints.down('sm')]: {
    fontSize: '36px',
  },
  [theme.breakpoints.up('sm')]: {
    fontSize: '40px',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '48px',
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '54px',
  },
  [theme.breakpoints.up('xl')]: {
    fontSize: '60px',
  }
}


// tour - room title
theme.typography.h2 = {
  
  fontFamily: "'微軟正黑體', 'texgyreadventorregular' ! important",
  fontWeight: 400,
  [theme.breakpoints.down('sm')]: {
    fontSize: '22px',
  },
  [theme.breakpoints.up('sm')]: {
    fontSize: '28px',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '32px',
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '36px',
  },
  [theme.breakpoints.up('xl')]: {
    fontSize: '38px',
  }
}

theme.typography.h3 = {
  
  fontFamily: "'微軟正黑體', 'texgyreadventorregular' ! important",
  fontWeight: 400,
  [theme.breakpoints.down('xs')]: {
    fontSize: '16px',
  },
  [theme.breakpoints.up('xs')]: {
    fontSize: '20px',
  },
  [theme.breakpoints.up('sm')]: {
    fontSize: '20px',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '26px',
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '30px',
  },
  [theme.breakpoints.up('xl')]: {
    fontSize: '30px',
  }
}

// 1. header navlink
theme.typography.h4 = {
  
  fontFamily: "'微軟正黑體', 'texgyreadventorregular' ! important",
  fontWeight: 400,
  [theme.breakpoints.down('xs')]: {
    fontSize: '16px',
  },
  [theme.breakpoints.up('xs')]: {
    fontSize: '16px',
  },
  [theme.breakpoints.up('sm')]: {
    fontSize: '17px',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '20px',
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '24px',
  },
  [theme.breakpoints.up('xl')]: {
    fontSize: '24px',
  }
}

// tour - room seciton description
// room - hardware description
theme.typography.h5 = {
  
  fontFamily: "'微軟正黑體', 'texgyreadventorregular' ! important",
  fontWeight: 400,

  [theme.breakpoints.down('xs')]: {
    fontSize: '16px',
  },
  [theme.breakpoints.up('xs')]: {
    fontSize: '16px',
  },
  [theme.breakpoints.up('sm')]: {
    fontSize: '16px',
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '16px',
  },

  [theme.breakpoints.up('lg')]: {
    fontSize: '16px',
  },

  [theme.breakpoints.up('xl')]: {
    fontSize: '18px',
  },


}

export default theme;


// WEBPACK FOOTER //
// ./src/helpers/theme.js